import { ApiError } from 'EstraSponsor'
import React, { useEffect } from 'react'

export const FORM_ERROR_DATA_ATTRIBUTE = 'data-focus-on-error'

// Add a specific attribute to a form element if it has an error (Then used in method below)
export const addErrorDataAttribute = (
  hasError: boolean
): { 'data-focus-on-error': string } | undefined =>
  hasError ? { [FORM_ERROR_DATA_ATTRIBUTE]: 'true' } : undefined

type Props = {
  error: Maybe<ApiError>
}

export const ErrorFormScrollHandler = ({ error }: Props): JSX.Element => {
  useEffect(() => {
    if (!error) return

    setTimeout(() => {
      const firstError = document.querySelector(
        `[${FORM_ERROR_DATA_ATTRIBUTE}]`
      ) as HTMLInputElement
      if (firstError) {
        firstError.scrollIntoView()
      }
    }, 100)
  }, [error])

  return <></>
}
